import React from 'react';
import { Icon } from '@iconify/react';
import '../../styles/kkp-planning-view-mode.scss';

/**
 * Sélecteur d’onglets.
 * - variant "pill" (défaut) : pilules Clients / Dispos des plannings KKP.
 * - variant "segment" : piste soft + actif blanc (maquette Pilotage Semaine).
 * - variant "underline" : onglets soulignés (maquette Mes tâches).
 *
 * @param {{
 *   options: Array<{ value: string, label: string, icon?: string, hint?: string, count?: number|null, countTone?: 'warn'|string, suffix?: React.ReactNode, disabled?: boolean }>,
 *   value: string,
 *   onChange?: (value: string) => void,
 *   ariaLabel?: string,
 *   className?: string,
 *   disabled?: boolean,
 *   variant?: 'pill' | 'segment' | 'underline',
 * }} props
 */
const AppPillSwitch = ({
  options = [],
  value,
  onChange,
  ariaLabel = 'Sélecteur',
  className = '',
  disabled = false,
  variant = 'pill',
}) => {
  const isSegment = variant === 'segment';
  const isUnderline = variant === 'underline';
  const rootClass = [
    'kkp-planning-view-switch',
    isSegment ? 'kkp-planning-view-switch--segment' : '',
    isUnderline ? 'kkp-planning-view-switch--underline' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={rootClass}
      role={isSegment || isUnderline ? 'tablist' : 'group'}
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const isActive = value === option.value;
        const isDisabled = disabled || Boolean(option.disabled);

        return (
          <button
            key={option.value}
            type="button"
            role={isSegment || isUnderline ? 'tab' : undefined}
            className={`kkp-planning-view-switch__btn${isActive ? ' is-active' : ''}`}
            aria-pressed={isSegment || isUnderline ? undefined : isActive}
            aria-selected={isSegment || isUnderline ? isActive : undefined}
            aria-current={isUnderline && isActive ? 'page' : undefined}
            title={option.hint}
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) onChange?.(option.value);
            }}
          >
            {option.icon ? (
              <Icon icon={option.icon} className="kkp-planning-view-switch__icon" aria-hidden />
            ) : null}
            <span>{option.label}</span>
            {option.count != null && (
              <span className={`kkp-planning-view-switch__count${option.countTone === 'warn' ? ' is-warn' : ''}`}>{option.count}</span>
            )}
            {option.suffix}
          </button>
        );
      })}
    </div>
  );
};

export default AppPillSwitch;
